import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Region } from "../../common/layout/region";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import {
	updateCompanyUserAuthorization,
	addNewTeamMember,
} from "../../../actions/companyActions";
import {
	Table,
	Input,
	Select,
	Form,
	Card,
	Row,
	Col,
	Modal,
	message,
	Menu,
	Dropdown,
	Avatar,
} from "antd";
import {
	PlusOutlined,
	UserOutlined,
	LockOutlined,
	MailOutlined,
	EllipsisOutlined,
	DeleteOutlined,
	EditOutlined,
} from "@ant-design/icons";
import { RefreshIcon } from "../../common/icons";
import DeleteMemberModal from "./deleteMemberModal";
import GalkButton from "../../common/component/button";

const { Option } = Select;

const EditableCell = ({
	inputType,
	editing,
	dataIndex,
	title,
	record,
	index,
	children,
	...restProps
}) => {
	const { t } = useTranslation();
	const getInput = () => {
		if (inputType === "dropdown") {
			const select = (
				<Select defaultValue="Admin" style={{ width: "100%" }}>
					<Option value="Admin">
						{t("accountSetting_teamMember_roleOption_admin")}
					</Option>
					<Option value="TeamMember">
						{t("accountSetting_teamMember_roleOption_teamMember")}
					</Option>
					<Option value="Visitor">
						{t("accountSetting_teamMember_roleOption_visitor")}
					</Option>
				</Select>
			);
			return select;
		}
		if (inputType === "disabledField") {
			return <Input disabled />;
		}
		return <Input />;
	};

	return (
		<td {...restProps}>
			{editing ? (
				<Form.Item
					name={dataIndex}
					style={{
						margin: 0,
					}}
					rules={[
						{
							required: true,
							message: `Please give Input!`,
						},
					]}
				>
					{getInput()}
				</Form.Item>
			) : (
				children
			)}
		</td>
	);
};

const TeamMember = ({
	company,
	teamMembers,
	updateCompanyUserAuthorization,
	user,
	addNewTeamMember,
	match,
	history,
}) => {
	const [form1] = Form.useForm();
	const [form2] = Form.useForm();

	const [editingKey, setEditingKey] = useState("");
	const [showModal, setShowModal] = useState(false);
	const [recordToDelete, setRecordToDelete] = useState(null);

	const { t } = useTranslation();

	const isEditing = (record) => record.id === editingKey;

	const edit = (record) => {
		if (record.id === user.id) {
			message.warning(
				"Please goto Personal Account tab to change your details !"
			);
		} else {
			form2.setFieldsValue({
				...record,
			});

			setEditingKey(record.id);
		}
	};

	const cancel = () => {
		setEditingKey("");
	};

	const save = async (key) => {
		try {
			const row = await form2.validateFields();
			const newData = [...teamMembers];
			const index = newData.findIndex((item) => key === item.id);

			if (index > -1) {
				const item = newData[index];
				newData.splice(index, 1, {
					...item,
					...row,
				});
				setEditingKey("");
				updateCompanyUserAuthorization(newData, newData[index]);
			} else {
				setEditingKey("");
			}
		} catch (err) {
			console.log("Validate Failed:", err);
		}
	};

	const menu = (record) => {
		return (
			<Menu>
				<Menu.Item key="edit" onClick={() => edit(record)}>
					<EditOutlined
						style={{ fontSize: "15px", cursor: "pointer", marginRight: "10px" }}
					/>
					{t("projectCard_action_edit")}
				</Menu.Item>
				<Menu.Item key="delete" onClick={() => setRecordToDelete(record)}>
					<DeleteOutlined
						style={{ fontSize: "15px", cursor: "pointer", marginRight: "10px" }}
					/>
					{t("projectCard_action_delete")}
				</Menu.Item>
			</Menu>
		);
	};

	const columns = [
		{
			title: "",
			dataIndex: "profilePic",
			width: "10%",
			editable: false,
			render: (_, { profilePic }) => {
				return profilePic ? (
					<Avatar size={50} src={profilePic} />
				) : (
					<Avatar size={50} icon={<UserOutlined />} />
				);
			},
		},
		{
			title: t("accountSetting_teamMember_tableHeader_name"),
			dataIndex: "name",
			width: "20%",
			editable: true,
		},
		{
			title: t("accountSetting_teamMember_tableHeader_authority"),
			dataIndex: "role",
			width: "20%",
			editable: true,
		},
		{
			title: t("accountSetting_teamMember_tableHeader_email"),
			dataIndex: "email",
			width: "30%",
			editable: true,
		},
		{
			title: t("accountSetting_teamMember_tableHeader_manage"),
			dataIndex: "operation",
			width: "20%",
			render: (_, record) => {
				if (record.id === user.id) return null;
				const editable = isEditing(record);
				return editable ? (
					<>
						<GalkButton
							type="primary"
							onClick={() => save(record.id)}
							height={36}
							width={90}
							additionalStyle={{ padding: "13px 16px", marginBottom: 10 }}
						>
							<RefreshIcon width={14} height={14} />
							{t("accountSetting_teamMember_tableRowAction_updateButton")}
						</GalkButton>
						<GalkButton
							type="secondary"
							onClick={cancel}
							height={36}
							width={90}
							additionalStyle={{ padding: "13px 16px" }}
						>
							{t("accountSetting_teamMember_tableRowAction_cancelButton")}
						</GalkButton>
					</>
				) : (
					<Dropdown
						overlay={menu(record)}
						trigger={["click"]}
						key="ellipsis"
						placement="bottomRight"
					>
						<EllipsisOutlined style={{ fontSize: "30px", cursor: "pointer" }} />
					</Dropdown>
				);
			},
		},
	];

	const toggle = () => {
		setShowModal(!showModal);
	};

	const getInputType = (dataIndex) => {
		if (dataIndex === "role") return "dropdown";
		if (dataIndex === "email") return "disabledField";

		return "text";
	};

	const _columns = columns.map((col) => {
		if (!col.editable) {
			return col;
		}
		return {
			...col,
			onCell: (record) => ({
				record,
				inputType: getInputType(col.dataIndex),
				dataIndex: col.dataIndex,
				title: col.title,
				editing: isEditing(record),
			}),
		};
	});

	const saveNewTeamMember = ({
		newMemberName,
		newMemberPassword,
		newMemberEmail,
		newMemberAccountType,
	}) => {
		const _newMember = {
			id: "a12",
			name: newMemberName,
			password: newMemberPassword,
			email: newMemberEmail,
			role: newMemberAccountType || "Admin",
			approvalStatus: "Approved",
			active: true,
		};
		// console.log("VALUES:", _newMember);
		addNewTeamMember(_newMember);
		toggle();
	};

	const onMenuChange = ({ key }) => {
		if (key === "1") history.push("/AccountSetting/Companyprofile");
	};

	return (
		<Region>
			<div className="accountSetting_pageTitle">
				{company ? company.nameInEnglish : `${t("company_profile")}`}
			</div>
			<Menu
				mode="horizontal"
				defaultSelectedKeys={["2"]}
				onClick={onMenuChange}
			>
				<Menu.Item key="1">
					{t("accountSetting_companyInfo_tabHeader")}
				</Menu.Item>
				<Menu.Item key="2">
					{t("accountSetting_memberInfo_tabHeader")}
				</Menu.Item>
			</Menu>
			<div className="accountSetting_companyProfile_bodyContainer">
				<Card
					title={t("accountSetting_teamMember_pageTitle")}
					style={{
						width: "100%",
						height: "85vh",
					}}
					extra={
						<GalkButton type="primary" width={180} onClick={toggle}>
							<PlusOutlined />
							{t("accountSetting_teamMember_pageAction_addmember")}
						</GalkButton>
					}
				>
					<Row>
						<Col lg={24}>
							{teamMembers && (
								<Form name="TeamMemberEdit" component={false} form={form2}>
									<Table
										components={{
											body: {
												cell: EditableCell,
											},
										}}
										dataSource={teamMembers}
										columns={_columns}
										rowClassName="editable-row"
										pagination={false}
									/>
								</Form>
							)}
						</Col>
					</Row>
					<Row>
						<Modal
							title={t("accountSetting_teamMember_pageAction_addmember")}
							onCancel={toggle}
							visible={showModal}
							footer={null}
						>
							<Form
								name="TeamMemberAdd"
								layout="vertical"
								onFinish={saveNewTeamMember}
								form={form1}
							>
								<Form.Item
									label={t(
										"accountSetting_teamMember_addMemberModal_fieldLabel_name"
									)}
									name="newMemberName"
									rules={[
										{
											required: true,
											message: "Please enter new member name",
										},
									]}
								>
									<Input
										placeholder="John Doe"
										prefix={<UserOutlined className="site-form-item-icon" />}
									/>
								</Form.Item>
								<Form.Item
									label={t(
										"accountSetting_teamMember_addMemberModal_fieldLabel_email"
									)}
									name="newMemberEmail"
									rules={[
										{
											type: "email",
											required: true,
											message: "Please enter email in valid format !",
										},
									]}
								>
									<Input
										prefix={<MailOutlined className="site-form-item-icon" />}
										placeholder="aa@example.com"
									/>
								</Form.Item>
								<Form.Item
									label={t(
										"accountSetting_teamMember_addMemberModal_fieldLabel_password"
									)}
									name="newMemberPassword"
									rules={[
										{
											required: true,
											message: "Please enter a default password !",
										},
									]}
								>
									<Input.Password
										prefix={<LockOutlined className="site-form-item-icon" />}
										placeholder="Password"
									/>
								</Form.Item>
								<Form.Item
									label={t(
										"accountSetting_teamMember_addMemberModal_fieldLabel_role"
									)}
									name="newMemberAccountType"
									rules={[
										{
											required: true,
										},
									]}
								>
									<Select defaultValue="Admin" placeholder="Select a role">
										<Option value="Admin">
											{t("accountSetting_teamMember_roleOption_admin")}
										</Option>
										<Option value="TeamMember">
											{t("accountSetting_teamMember_roleOption_teamMember")}
										</Option>
										<Option value="Visitor">
											{t("accountSetting_teamMember_roleOption_visitor")}
										</Option>
									</Select>
								</Form.Item>
								<Form.Item>
									<div
										style={{
											display: "flex",
											justifyContent: "center",
											gap: 10,
										}}
									>
										<GalkButton
											onClick={toggle}
											type="secondary"
											height={36}
											additionalStyle={{ padding: "13px 16px" }}
										>
											{t(
												"accountSetting_teamMember_addMemberModal_action_cancel"
											)}
										</GalkButton>
										<GalkButton
											type="primary"
											htmlType="submit"
											height={36}
											additionalStyle={{ padding: "13px 16px" }}
										>
											{t("accountSetting_teamMember_addMemberModal_action_add")}
										</GalkButton>
									</div>
								</Form.Item>
							</Form>
						</Modal>
					</Row>
				</Card>
			</div>
			{recordToDelete && (
				<DeleteMemberModal
					member={recordToDelete}
					modalCloseHandler={() => setRecordToDelete(null)}
				/>
			)}
		</Region>
	);
};

const mapStateToProps = (state) => ({
	company: state.company.company,
	teamMembers: state.company.company.accountUserList,
	user: state.firebase.profile,
});

export default connect(mapStateToProps, {
	updateCompanyUserAuthorization,
	addNewTeamMember,
})(withRouter(TeamMember));
